$(document).ready(function() {
  $(window).scroll(function() {
      if($(this).scrollTop() > 1000) {
          $("#js-cta").fadeIn(400)
      } else {
          $("#js-cta").hide();
      }
  });
})